import { Box, Button, Collapse, Typography } from '@mui/material';

import { Link } from '@tanstack/react-router';
import Caution from '@assets/icons/caution-error.svg';

interface TermsDataProps {
  errorMessage?: string | null;
  isSubmitting?: boolean;
  timeoutProgress: number;
}

const TermsData = ({
  errorMessage,
  isSubmitting,
  timeoutProgress,
}: TermsDataProps) => {
  return (
    <Box
      sx={{
        boxShadow: '0px 4px 4px 0px #00000040',
        borderRadius: '12px',
        backgroundColor: '#FFF',
        py: { xs: '24px', md: '40px' },
        px: { xs: '24px', md: '88px' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: '24px', lg: '58px' },
          alignItems: 'center',
        }}
      >
        <Link
          to="/"
          onClick={() => {
            localStorage.removeItem('asasAccessToken');
            localStorage.removeItem('consultaCredito');
          }}
          disabled={isSubmitting}
          style={{
            color: '#808080',
            textDecoration: 'underline',
            fontWeight: 700,
            fontSize: '14px',
            textAlign: 'center',
          }}
        >
          Voltar para Consulta
        </Link>

        <Button
          variant="contained"
          type="submit"
          disabled={isSubmitting}
          sx={{
            position: 'relative',
            overflow: 'hidden',
            backgroundColor: '#004AA0',
            fontWeight: 700,
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '14px',
            padding: '8px 44px',
            textTransform: 'none',
            width: { md: '325px' },
            '&:hover': {
              backgroundColor: '#003c85',
            },
            '&:disabled': {
              backgroundColor: '#ccc',
              color: '#666',
            },
          }}
        >
          <Box
            component="span"
            sx={{
              position: 'relative',
              zIndex: 1,
            }}
          >
            {isSubmitting
              ? 'Processando...'
              : errorMessage
                ? 'Tentar Novamente'
                : 'Solicitar Cotação'}
          </Box>

          {!!isSubmitting && (
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                width: `${timeoutProgress}%`,
                backgroundColor: '#2064b8',
                zIndex: 0,
                transition: 'width 100ms linear',
              }}
            />
          )}
        </Button>
      </Box>

      <Collapse in={!!errorMessage}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '24px',
            px: { xs: '24px', md: '40px' },
            py: '24px',
            backgroundColor: '#FF950026',
            borderRadius: '13px',
            mt: '16px',
          }}
        >
          <Box
            component="img"
            src={Caution}
            alt="Caution Icon"
            sx={{ width: { xs: '28px' }, height: { xs: '24px' } }}
          />
          <Typography
            sx={{ color: '#808080', fontSize: { xs: '14px', md: '16px' } }}
          >
            {errorMessage}
          </Typography>
        </Box>
      </Collapse>
    </Box>
  );
};

export default TermsData;
